import { useRef } from 'react'

export const useLatestDefinedValue = <T>(value: T) => {
  const lastValue = useRef(value)
  if (value !== undefined) {
    lastValue.current = value
  }
  return lastValue.current
}
